import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  image: FelaCSS;
  noImage: FelaCSS;
  authorWrapper: FelaCSS;
  authorName: FelaCSS;
  authorDetails: FelaCSS;
  authorAboutMe: FelaCSS;
  whenUpdated: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    gap: 13,
    maxWidthMobile: {
      flexDirection: 'row',
    },
  },
  image: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noImage: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  authorWrapper: {
    justifyContent: 'center',
    cursor: 'pointer',
  },
  authorName: {
    zIndex: 10,
    fontDefaultSemiBold: 14,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  authorDetails: {
    flexDirection: 'row',
    gap: 5,
    fontDefault: 12,
  },
  authorAboutMe: {
    fontDefault: 12,
    color: colors.space60,
    marginTop: 2,
  },
  whenUpdated: {
    fontDefault: 12,
    color: colors.space60,
  },
});

export default styles;
